/**
 * YT Analytics — fires add_to_cart for ajax / mini-cart flows.
 * Matches existing view_item dataLayer shape (product-ritual / product-template).
 */
(function () {
  'use strict';

  var lastTrackKey = '';
  var lastTrackAt = 0;

  function currencyCode() {
    if (window.Shopify && Shopify.currency && Shopify.currency.active) {
      return Shopify.currency.active;
    }
    return 'GBP';
  }

  function lineItemPayload(item) {
    if (!item) return null;

    var variantId = item.variant_id || item.id;
    if (!variantId) return null;

    var qty = item.quantity || 1;
    var unitPriceCents = item.final_price != null ? item.final_price : item.price;
    if (unitPriceCents == null) return null;

    var linePriceCents = item.final_line_price != null
      ? item.final_line_price
      : unitPriceCents * qty;

    var productTitle = item.product_title || item.title || '';
    var variantTitle = item.variant_title || '';
    if (variantTitle === 'Default Title') variantTitle = '';

    return {
      currency: currencyCode(),
      value: linePriceCents / 100,
      quantity: qty,
      unitPrice: unitPriceCents / 100,
      item_id: String(item.product_id || variantId),
      item_name: productTitle,
      item_variant: variantTitle,
      item_brand: item.vendor || '',
      item_category: item.product_type || '',
      sku: item.sku || '',
      variant_id: String(variantId)
    };
  }

  function flushDeferredGoogleAds() {
    if (typeof window.YTFlushGoogleAds === 'function') {
      window.YTFlushGoogleAds();
    }
  }

  function pushDataLayerAddToCart(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: payload.currency,
        value: payload.value,
        items: [{
          item_id: payload.item_id,
          item_name: payload.item_name,
          item_brand: payload.item_brand,
          item_category: payload.item_category,
          item_variant: payload.item_variant,
          price: payload.unitPrice,
          quantity: payload.quantity
        }]
      }
    });
  }

  function publishShopifyAddToCart(payload) {
    var analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function') return;

    try {
      analytics.publish('product_added_to_cart', {
        cartLine: {
          cost: {
            totalAmount: {
              amount: payload.value,
              currencyCode: payload.currency
            }
          },
          merchandise: {
            id: 'gid://shopify/ProductVariant/' + payload.variant_id,
            title: payload.item_variant || payload.item_name,
            sku: payload.sku,
            product: {
              id: 'gid://shopify/Product/' + payload.item_id,
              title: payload.item_name,
              vendor: payload.item_brand,
              type: payload.item_category
            },
            price: {
              amount: payload.unitPrice,
              currencyCode: payload.currency
            }
          },
          quantity: payload.quantity
        }
      });
    } catch (_err) {
      /* non-fatal */
    }
  }

  function trackAddToCart(item) {
    var payload = lineItemPayload(item);
    if (!payload) return;

    var trackKey = payload.variant_id + 'x' + payload.quantity;
    var now = Date.now();
    if (trackKey === lastTrackKey && now - lastTrackAt < 1000) return;
    lastTrackKey = trackKey;
    lastTrackAt = now;

    flushDeferredGoogleAds();
    pushDataLayerAddToCart(payload);
    publishShopifyAddToCart(payload);
  }

  window.YTAnalytics = {
    trackAddToCart: trackAddToCart
  };
})();
